import React from 'react';
import { Header, Icon } from 'semantic-ui-react';
import { FutureReadinessFilters } from './FutureReadinessFilters';
import { FutureReadinessReport } from './FutureReadinessReport';
import { useFutureReadinessReport } from './hooks';

export const FutureReadinessPage = () => {
    const {
        startDate, setStartDate,
        endDate, setEndDate,
        selectedTeamIds, setSelectedTeamIds,
        teamOptions, teamsLoading,
        data, loading, error, setError,
        exporting, generateReport, exportReport,
    } = useFutureReadinessReport();

    return (
        <div style={{ padding: '1.5rem 2rem', maxWidth: '1400px', margin: '0 auto' }}>
            <Header as="h2" textAlign="center" className="fr-page-header">
                <Icon name="calendar check outline" />
                <Header.Content>
                    Future Readiness Planning
                    <Header.Subheader>
                        Member availability, assets out of service, and open roadblocks by team
                    </Header.Subheader>
                </Header.Content>
            </Header>

            <FutureReadinessFilters
                startDate={startDate}
                setStartDate={setStartDate}
                endDate={endDate}
                setEndDate={setEndDate}
                selectedTeamIds={selectedTeamIds}
                setSelectedTeamIds={setSelectedTeamIds}
                teamOptions={teamOptions}
                teamsLoading={teamsLoading}
                loading={loading}
                exporting={exporting}
                onGenerate={generateReport}
                onExport={exportReport}
                error={error}
                setError={setError}
            />

            <FutureReadinessReport
                data={data}
                loading={loading}
                error={error}
            />
        </div>
    );
};
